import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import { IconButton, Menu, MenuItem, Avatar } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import blankProfile from "../../img/hotgig-loading.png";

@inject("templateStore", "notificationStore", "profileStore")
@withRouter
@observer
class NotificationItem extends Component {
    state = {
        anchorMenu: null
    };

    handleCloseNotificationPopover = () => {
        this.props.templateStore.setNotificationPopoverAnchor(null);
    };

    handleClickMenu = event => {
        event.preventDefault();
        this.setState({ anchorMenu: event.currentTarget });
    };

    handleCloseMenu = () => {
        this.setState({ anchorMenu: null });
    };

    handleRead = async () => {
        const { notification } = this.props;
        this.handleCloseMenu();
        this.handleCloseNotificationPopover();
        await this.props.notificationStore.read(notification);
    };

    handleDelete = () => {
        const { notification } = this.props;
        this.handleCloseMenu();
        this.props.notificationStore.delete(notification);
    };

    handleClick = async () => {
        const { notification } = this.props;

        // let forwardUrl = GetNotificationLink(notification);

        // if (notification && notification.toProfile) {
        //     var newProfileType = notification.toProfile.type;
        //     if (newProfileType === ProfileType.Act.ordinal) {
        //         newProfileType = ProfileType.Musician.ordinal;
        //     } else if (newProfileType === ProfileType.Venue.ordinal) {
        //         newProfileType = ProfileType.Staff.ordinal;
        //     }

        //     this.props.profileStore.setProfileType(newProfileType);
        // }
        // if (this.props.history.location.pathname === forwardUrl) {
        //     window.location.reload();
        // } else {
        //     this.props.history.push(forwardUrl);
        // }
        // this.props.notificationStore.setHistory(this.props.history);


        //this.props.history.push(forwardUrl);

        await this.handleRead();
        setTimeout(this.props.notificationStore.gotoPage(notification), 3000);
    };

    render() {
        const { anchorMenu } = this.state;
        const { notification } = this.props;

        return (
            <div className={notification.isRead ? "read" : "unread"}>
                <ListItem button>
                    <ListItemAvatar onClick={this.handleClick}>
                        <Avatar src={typeof notification.profileImageUrl === "undefined" ? blankProfile : notification.profileImageUrl} />
                    </ListItemAvatar>
                    <ListItemText
                        onClick={this.handleClick}
                        primary={<div dangerouslySetInnerHTML={{ __html: notification.generatedMessage}} />}
                        disableTypography={false}
                    />
                    <ListItemSecondaryAction>
                        <IconButton aria-label="Action" onClick={this.handleClickMenu}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu id="notif-menu" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={this.handleCloseMenu}>
                            <MenuItem onClick={this.handleRead}>Mark as read</MenuItem>
                            <MenuItem onClick={this.handleDelete}>Delete</MenuItem>
                        </Menu>
                    </ListItemSecondaryAction>
                </ListItem>
            </div>
        );
    }
}

export default NotificationItem;
